<template>

	<app-boards board-key="trend_events"></app-boards>

</template>

<script>
import AppBoards from "@/components/boards/appBoards";
export default {
	name: "event",
	components: {AppBoards}
}
</script>

<style scoped>

</style>